var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["partials/account-navigation-h2-medium.j2"] = require( "partials/account-navigation-h2-medium.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/partials/account-navigation-h2.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<h2 class=\"o-secondary-navigation__h2 u-extra-small--show u-medium--hide js-dropdown-toggle js-account-nav-dropdown\" data-qa-account-nav-dropdown>\n    <p class=\"o-secondary-navigation__p o-secondary-navigation__title\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, [env.getFilter("default").call(context, runtime.contextOrFrameLookup(context, frame, "h2Slug"),"account_navigation-my-account"),runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "secondaryH2Text"), env.opts.autoescape);
output += "\n    </p>\n</h2>\n\n";
env.getTemplate("partials/account-navigation-h2-medium.j2", false, "core/templates/partials/account-navigation-h2.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/partials/account-navigation-h2.j2"] , dependencies)